import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from '.'

export const CsLockIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M182.857 448h292.571V338.286q0-60.571-42.857-103.429T329.142 192t-103.429 42.857-42.857 103.429V448zm475.429 54.857V832q0 22.857-16 38.857t-38.857 16H54.858q-22.857 0-38.857-16T.001 832V502.857q0-22.857 16-38.857t38.857-16h18.286V338.286q0-105.143 75.429-180.571t180.571-75.429 180.571 75.429 75.429 180.571V448h18.286q22.857 0 38.857 16t16 38.857z" />
    </g>
  </StyledIcon>
)

CsLockIcon.displayName = 'CsLockIcon'
